import React, {useEffect, useState} from 'react';
import OrgFamilyMembersSaleMainPage from './OrgFamilyMembersSaleMainPage/OrgFamilyMembersSaleMainPage';
import {saveToHistory, setCellularPlanForSale, setProgramCurrentStep, cleanSliceData} from '../familyMemberCellularSaleSlice';
import {PROGRAM_STEPS, OPTION_INPUT_TYPES, pathHistory, orgFamilyMembersSalePages} from './enums';
import {connect} from 'react-redux';
import SuccessOrErrorScreen from './successOrErrorScreen/SuccessOrErrorScreen';
import ProgressBar from '../../../Shared/ProgressBar/progressBar';
import thumb_up from './images/thumb_up.svg';
import hey from './images/hey.svg';
import FamilyMemberCellularSaleMain from '../FamilyMemberCellularSaleMain';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../Config';

const OrgFamilyMembersSale = (props) => {
  const [currentStep, setStep] = useState(props.store?.programCurrentStep);

  const getCurrentStep = () => {
    switch (props.store?.programCurrentStep) {
      case PROGRAM_STEPS.MAIN: {
        props.saveToHistory(pathHistory.main);
        return <OrgFamilyMembersSaleMainPage iContent={props.iContent} />;
      }
      case PROGRAM_STEPS.TRANSFER_LINE_SUCCESS: {
        props.saveToHistory(pathHistory.transferLineSuccess);
        props.setCellularPlanForSale(OPTION_INPUT_TYPES.TRANSFER_LINE);
        return (
          <SuccessOrErrorScreen
            popUpObj={{
              icon: thumb_up,
              heading: `איזה כייף שבחרת לצרף ל${window.Config.brand_Name_HE} בן משפחה!`,
              secondaryHeading: 'מיד נשלח SMS עם לינק הצטרפות למספר',
              phoneNumber: props.store.optionsData?.['option' + props.store.selected]?.input,
              buttonText: 'סיום',
              btnClickedCallBack: () => {
                EpiContext.navigateTo(Config.lobbyUrl);
                props.cleanSliceData();
              },
            }}
          />
        );
      }
      case PROGRAM_STEPS.TRANSFER_LINE_CAPACITY_FAILURE: {
        props.saveToHistory(pathHistory.transferLineCapacityFailure);
        return (
          <SuccessOrErrorScreen
            popUpObj={{
              icon: hey,
              heading: 'מימשת 9/9 הטבות של תוכנית בני משפחות',
              whiteBlackBtn: {
                text: 'לפרטים ומידע נוסף התקשרו ל-2759*',
              },
              buttonText: 'הבנתי, תודה',
              btnClickedCallBack: () => props.setProgramCurrentStep(PROGRAM_STEPS.MAIN),
            }}
          />
        );
      }
      case PROGRAM_STEPS.TRANSFER_LINE_ML_FAILURE: {
        props.saveToHistory(pathHistory.transferLineMlFailure);
        return (
          <SuccessOrErrorScreen
            popUpObj={{
              icon: hey,
              heading: 'מצטערים, משהו השתבש בתהליך ולא ניתן לבצע את הפעולה שביקשת',
              secondaryHeading: 'נציגנו ישמחו לסייע לך',
              whiteBlackBtn: {
                text: 'לפרטים ומידע נוסף התקשרו ל-2759*',
              },
              buttonText: 'חזרה לאיזור האישי',
              btnClickedCallBack: () => {
                EpiContext.navigateTo(Config.lobbyUrl);
                props.cleanSliceData();
              },
            }}
          />
        );
      }
      case PROGRAM_STEPS.NEW_LINE_SHOW_SALE_PACKAGES: {
        props.saveToHistory(pathHistory.showCellularPackages);
        props.setCellularPlanForSale(OPTION_INPUT_TYPES.NEW_LINE);
        return <FamilyMemberCellularSaleMain context={props.context} iContent={props.iContent} completed={true} />;
      }
      default: {
        props.saveToHistory(pathHistory.main);
        return <OrgFamilyMembersSaleMainPage iContent={props.iContent} />;
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setStep(getCurrentStep());
  }, [props.store.programCurrentStep]);

  return (
    <>
      <ProgressBar points={[]} percent={orgFamilyMembersSalePages[props.store?.programCurrentStep] ?? '0'} />
      {currentStep}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    store: state.familyMemberCellularSale,
  };
};

const mapDispatchToProps = {
  saveToHistory,
  setCellularPlanForSale,
  setProgramCurrentStep,
  cleanSliceData,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgFamilyMembersSale);
